var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasContractor)?_c('CoBrandedPageCustomer'):_vm._e(),(_vm.hasPartner)?_c('CoBrandedPagePartner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }